<template>
  <div class="kaiying" id="kaiying">
    <!-- ps img -->
    <div class="con-imgs-box">
      <img class="con-img" :src="backUrl">
    </div>
  </div>
</template>
<script>
export default {
  name: "kaiying",
  data() {
    return {
      msg: "kaiying page",
      backUrl : "https://ytk-front.oss-cn-beijing.aliyuncs.com/hybrid/h5/yanda-h5/2024-02-20/wqky.jpg"
    };
  },
};
</script>
<style lang="less" scoped>
.con-imgs-box {
  .con-img {
    display: block;
    width: 100%;
    margin: 0;
    padding: 0;
    outline: none;
  }
}
</style>

